import React from "react";
import styled from "styled-components";
import { H3, Caption } from "../../styled/typograpghy.styled";
import { FlexContainer } from "../../styled/layout.styled";
import LoginMobileList from "./LoginMobileList";
import { getLoginUrl } from "../../../redux/modules/auth";
import walletProviders from "../../../config/walletProviders";

const StyledAnchor = styled.a`
  width: 320px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  padding: 12px 24px;
  color: rgb(31, 13, 83);
  align-items: center;
  background-color: ${({ theme }) => theme.color.white};
  transition: all 0.3s ease;
  margin: ${({ margin }) => margin};
  &:hover {
    color: rgb(31, 13, 83);
    background-color: #f0ecff;
  }
  @media only screen and (max-width: 568px) {
    width: 312px;
  }
`;

const StyledCaption = styled.a`
  color: ${({ theme }) => theme.color.lightGreen};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.color.lightGreen};
  }
`;

const LoginContent = () => (
  <>
    <FlexContainer mobileFlexDirection="column">
      <FlexContainer
        flexDirection="column"
        alignItems="center"
        padding="120px 0 480px 0"
        mobilePadding="60px 0 120px 0"
      >
        <H3 margin="0 0 40px 0"> Sign in to Peergame </H3>
        <StyledAnchor href={getLoginUrl("handcash")}>
          <img style={{ marginRight: "16px", height: "24px" }} src={walletProviders.handcash.icon} alt="" />
          <span className="bold">Sign in with HandCash</span>
        </StyledAnchor>
        <Caption margin="60px 0 4px 0" className="small">
          Don’t have a Bitcoin SV wallet?
        </Caption>
        <StyledCaption
          className="small"
          href="https://app.handcash.io/#/authenticate"
          target="_blank"
          rel="noreferrer noopener"
        >
          Create a Free Wallet
        </StyledCaption>
      </FlexContainer>
      <LoginMobileList />
    </FlexContainer>
  </>
);
export default LoginContent;
